<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      video: null,
    };
  },
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },

    slideIndex: {
      default: 0,
    },
    isTransitionFinished: {
      type: Boolean,
      default: false,
    },
    activeSlide: {
      type: Number,
      default: 0,
    },
    slide: {
      type: Object,
      default: () => {},
    },
    pathPrefix: {
      type: String,
      default: "https://res.cloudinary.com/vectorworks-mktg/video/upload/",
    },
    pathSufix: {
      type: String,
      default: `Rodrigo_tests_/launch_2023/`,
    },
  },
  created() {
    this.observer = new IntersectionObserver(this.loadVideo, {
      threshold: 0,
    });
  },
  computed: {
    ...mapGetters(["watchVideo"]),

    videoURL() {
      const srcStr = this.slide.videoUrl;
      return srcStr.split(/v\d{5,12}/);
    },
    videoInfo() {
      return {
        url: this.slide.videoUrl,
        poster: this.slide.poster,
        vimeoId: this.slide.vimeoId,
      };
    },
  },
  mounted() {
    this.observer.observe(this.$refs.video);
  },
  watch: {
    activeSlide() {
      if (this.activeSlide === this.slideIndex) {
        this.$refs.video;
      } else {
        this.$refs.video.currentTime = 0;
        this.$refs.video.pause();
      }
    },
  },
  methods: {
    ...mapActions(["toggleModal"]),

    loadVideo(entries) {
      const video = this.$refs.video;
      if (entries[0].isIntersecting === true) {
        for (const source in video.children) {
          const videoSource = video.children[source];
          if (
            typeof videoSource.tagName === "string" &&
            videoSource.tagName === "SOURCE"
          ) {
            videoSource.src = videoSource.dataset.src;
          }
          video.load();
          video.addEventListener("loadeddata", () => {
            this.$emit("video-loaded", video.getBoundingClientRect().height);
            console.log(video.getBoundingClientRect().height);
          });
          video.currentTime = 0;
          video.play();
        }
      }
    },
  },
};
</script>
<template>
  <div class="vw-slide">
    <video
      class="carouselVideo img1"
      muted
      loop
      playsinline
      ref="video"
      :poster="`${videoURL[0]}so_0${videoURL[1]}.jpg`"
    >
      <source
        :data-src="
          `${videoURL[0]}q_90/vc_h265/w_1920/c_limit/${videoURL[1]}.mp4`
        "
        type="video/mp4; codecs=hvc1"
      />
      <source
        :data-src="
          `${videoURL[0]}q_90/vc_vp9/w_1920/c_limit/${videoURL[1]}.webm`
        "
        type="video/webm; codecs=vp9"
      />
      <source
        :data-src="`${videoURL[0]}q_90/w_1920/c_limit/${videoURL[1]}.mp4`"
        type="video/mp4"
      />
    </video>
    <h2>{{ slide.title }}</h2>
    <p>
      {{ slide.description }}
      <a
        v-if="typeof videoInfo.vimeoId !== `undefined`"
        @click.prevent="toggleModal(videoInfo)"
        href="#"
        class="learnMore"
      >
        {{ watchVideo }}
      </a>
    </p>
  </div>
</template>
<style lang="scss" scoped>
@import "../styles/01-settings/breakpoints";
@import "../styles/01-settings/mq";
.vw-slide {
  // align-items: ;
  color: var(--text-color);
  display: flex;
  flex-direction: column;
  height: 100%;
  pjustify-content: flex-start;
  width: 100%;
  text-align: left;
}
.slide_img {
  width: 100%;
  height: 100%;
  aspect-ratio: 1/1;
  object-fit: cover;
}
h2 {
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0.16px;
  color: var(--text-color);
  line-height: 1;
  margin-bottom: 18px;
  padding: 0 30px;
}
p {
  // line-height: 1.75;
  color: var(--text-color);
  font-size: 16px;
  font-weight: 300;
  letter-spacing: 0.15px;
  margin-bottom: 0;
  padding: 0 30px;
}

.carouselVideo {
  --gridPadding: 30px;
  width: calc(100% + var(--gridPadding) * 2);
  margin-left: calc(-1 * var(--gridPadding));
  // height: 100%;
  object-fit: cover;
  aspect-ratio: var(--video-ratio);
  margin-bottom: 80px;
  border-radius: 0;
}

@include mq($from: sm, $until: md) {
  .vw-slide {
    padding: 0 30px;
  }
}
@include mq($from: sm, $until: lg) {
  h2 {
    font-size: 18px;
  }
}
</style>



// WEBPACK FOOTER //
// resources/assets/vuejs/frontend/2023-launch/components/VideoCarouselSlide.vue